import { render, staticRenderFns } from "./XSelect.vue?vue&type=template&id=4f4f9f57&scoped=true"
import script from "./XSelect.vue?vue&type=script&lang=js"
export * from "./XSelect.vue?vue&type=script&lang=js"
import style0 from "./XSelect.vue?vue&type=style&index=0&id=4f4f9f57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4f9f57",
  null
  
)

export default component.exports